import { axiosCustomer } from 'modules/axios'
import { CONFIG } from './environments'

export function checkCTCAOnFly(customerId) {
  return axiosCustomer({
    method: 'GET',
    url: `${CONFIG.api.orderOnFly}${customerId}/has_acc_inprogress`,
  }).then(resp => resp.data)
}
